import React from "react";
// import '../../styles/filemanager.scss'
import { translate } from "../utils/useful";
import Collapsible from "react-collapsible";
import HttpServices from "../utils/Http.services";

const LEFT_SIDE_BAR_PAGE_STATE = {
    NONE: -1,
    INBOX: 0,
    SENT: 1,
    DRAFT: 2,
    FLAGED: 3,
    SCHEDULED: 4,
    SETTINGS: 5
};
class NotebookSidebar extends React.Component {

    state = {
        show: false,

        pages: [
            { key: 'dashboard', label: 'All files', icon: '/assets/icons/applets/drive/all-files.svg' },
            // { key: 'recently', label: 'Recent', icon: '/assets/icons/applets/drive/recently.svg' },
            { key: 'starred', label: 'Starred', icon: '/assets/icons/applets/drive/starred.svg' },
            { key: 'trashed', label: 'Trash', icon: '/assets/icons/applets/drive/trash.svg' },
        ],

        applets: [
            { name: 'Company', icon: '/assets/profile-def.png' },
            { name: 'Family', icon: '/assets/profile-def.png' },
            { name: 'Friends', icon: '/assets/profile-def.png' },
        ],
        currentPage: 'dashboard',
        isOpen: { 0: true }

    }

    chengecollaps = (index) => {
        let isOpen = this.state.isOpen
        isOpen = {}
        isOpen[index] = !isOpen[index]

        this.setState({ isOpen })

    }
    componentDidMount() {
        this.init()
    }


    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
        }
    }

    init = () => {
        HttpServices.request('getNotes', {}, (fetchResolve, fetchError) => {
            if (fetchError) {
                console.log(fetchError);
            }
            console.log('fetchresolve', fetchResolve);
            this.setState({ notes: fetchResolve?.info })
        })
    }

    // createNote = () => {
    //     let data = { title: this.state.titleValue }
    //     this.setState({ titleValue: '' })
    //     this.setState({ bodyValue: '' })
    //     console.log('data is ', data);
    //     HttpServices.request('createNote', data, (fetchResolve, fetchError) => {
    //         if (fetchError) {
    //             console.log(fetchError);
    //         }
    //         this.init()
    //     })
    // }


    titleValue = (e) => {
        this.setState({ titleValue: e.target.value })
    }
    bodyValue = (e) => {
        this.setState({ bodyValue: e.target.value })
    }
    changePage = (item) => {
        console.log('item is :', item)
        this.setState({ titleValue: item.title })
        this.setState({ bodyValue: item.body })
    }
    render() {
        return (


            <div className='scroll-no-scrollbar h-100 w-100 d-flex flex-column'>
                <div className=' w-100'>
                    {this.state.applets.map((item, index) => {
                        return (
                            <div className='w-100' key={index}>
                                <div className={this.state.isOpen[index] ? 'leftsideItems' : ''} style={{ transition: "all 0.5s" }}>
                                    <div onClick={() => { this.chengecollaps(index) }} onChange={() => this.props.changeAppletsTab(item, index)} className='flexc w-100 py-1 px-3 cursor-pointer' style={{ backgroundColor: this.state.currentPage === item.key ? '#eee' : '' }}>
                                        <div className='flexc py-2'>
                                            <img className="mrd-3" src={item.icon} alt="" style={{ width: '20px', height: '20px', borderRadius: '20px' }} />
                                            <p className='font-size-16 weight-500' style={{ color: "#222" }}>{translate(item.name)}</p>
                                        </div>
                                    </div>
                                    <Collapsible open={this.state.isOpen[index]} >
                                        <div className=''>
                                            {this.state.notes ? this.state.notes.map((item, index) => {
                                                return (
                                                    <div className='' key={index} >
                                                        <button onClick={() => this.changePage(item)} className='d-flex w-100 px-3 py-3 cursor-pointer w-100 note-hover-box pld-4'>
                                                            <div className=''>
                                                                <div className='text-start'>
                                                                    <p className='font-size-14 weight-600 title-color'>{translate(item.title)}</p>
                                                                    <p className='font-size-12 weight-300' style={{ color: "#484848" }}>This is a Test Description</p>
                                                                    <p className='font-size-10 weight-300' style={{ color: "#858585" }}>November 14 2023</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                )
                                            }) : (
                                                <div></div>
                                            )}
                                        </div>
                                    </Collapsible>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}



export default NotebookSidebar 